import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/shared/ProtectedRoute';
import './App.css';
import Dashboard from './pages/dashboard/Dashboard';
import Users from './pages/users/Users';
import Restaurants from './pages/restaurants/Restaurants';
import RestaurantDetail from './pages/restaurants/RestaurantDetail';
import Orders from './pages/orders/Orders';
import Deals from './pages/deals/Deals';
import Transactions from './pages/transactions/Transactions';
import Documents from './pages/documents/Documents';
import HomepageManagement from './pages/homepage/HomepageManagement';
import SignIn from './pages/auth/SignIn';

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route 
        path="/signin" 
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <SignIn />
        } 
      />
      <Route 
        path="/" 
        element={
          <Navigate to={isAuthenticated ? "/dashboard" : "/signin"} replace />
        } 
      />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/users" 
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/restaurants" 
        element={
          <ProtectedRoute>
            <Restaurants />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/restaurants/:restaurantId" 
        element={
          <ProtectedRoute>
            <RestaurantDetail />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/orders" 
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/deals" 
        element={
          <ProtectedRoute>
            <Deals />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/transactions" 
        element={
          <ProtectedRoute>
            <Transactions />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/documents" 
        element={
          <ProtectedRoute>
            <Documents />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/homepage" 
        element={
          <ProtectedRoute>
            <HomepageManagement />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
};

const App: React.FC = () => (
  <Router>
    <AuthProvider>
      <div className="App">
        <AppRoutes />
      </div>
    </AuthProvider>
  </Router>
);

export default App;
